<template>
    <div class="p-3">
        <h4 class="text-dark">Control Center: My Centers</h4>

        <div class="bg-white border-light p-3 mt-3">
            <h4 class="text-capitalize">Center location, hours & calendar details</h4>

            <div v-for="(c, i) in widgetCenters.dataSource">
                <a
                    class="font-weight-bold link-primary float-right text-primary"
                    @click="editWidgetEntry('widgetCenters', c.id)"
                    >Edit</a
                >

                <div class="row mt-2">
                    <div class="col-6">
                        <h5 class="mb-0">{{ c.name }}</h5>
                        <p class="mb-0" v-if="c.address">
                            <span v-for="k in Object.keys(c.address).filter(k => k !== 'id')"
                                >{{ c.address[k] }}
                            </span>
                        </p>
                        <p class="mb-0">
                            <span>{{ c.opening_hours }}</span>
                        </p>
                    </div>
                    <div class="col-6" v-if="dates[i]">
                        <h6>Closed days:</h6>
                        <p class="mb-0 small" v-for="h in dates[i].dates.dates">
                            <span class="mr-4">{{ moment(h.date).format("MM/DD/YYYY") }}</span
                            ><span>{{ h.description }}</span>
                        </p>
                    </div>
                </div>
                <hr
                    v-if="i + 1 < widgetCenters.dataSource.length"
                    style="width:100%;margin: 0.5rem auto;color:#bfbfbf;background: #bfbfbf; height: 1px;"
                />
            </div>
            <p
                class="font-weight-bold cursor-pointer text-capitalize text-primary mt-4 mb-1"
                @click="openWidgetCentersModal()"
            >
                <i class="mr-2 fa fa-angle-right"></i>Add another center
            </p>
            <modal-component
                :id="`modal-centers`"
                :title="`Edit Center`"
                :visible="widgetCenters.modalVisible"
                @close="closeWidgetCentersModal()"
            >
                <form class="p-3">
                    <div class="form-group row">
                        <label for="name" class="col-4 mb-1">Name:</label>
                        <div class="col-8">
                            <input
                                id="name"
                                type="text"
                                class="form-control form-control-sm mb-1"
                                placeholder="Center name"
                                v-model="widgetCenters.payload.name"
                            />
                        </div>
                    </div>
                    <div class="form-group row mb-0">
                        <label for="opening_hours" class="col-4 mb-1">Opening Hours:</label>
                        <div class="col-8">
                            <textarea
                                id="opening_hours"
                                class="form-control mb-2"
                                rows="5"
                                v-model="widgetCenters.payload.opening_hours"
                                placeholder="e.g. 'Mon-Fri 8AM-6PM'"
                            ></textarea>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="blackout" class="col-4 mb-1">Holidays:</label>
                        <div class="col-8">
                            <template>
                                <div
                                    v-for="(blackoutDate, i) in widgetCenters.payload.dates"
                                    class="ml-2 small d-flex justify-content-between"
                                >
                                    <span
                                        >{{
                                            blackoutDate.date
                                                ? moment(blackoutDate.date).format("YYYY/MM/DD")
                                                : ""
                                        }}
                                        - {{ blackoutDate.description }}</span
                                    >
                                    <button
                                        @click.prevent="deleteBlackout(i)"
                                        class="btn btn-sm btn-link text-danger"
                                    >
                                        Delete
                                    </button>
                                </div>
                            </template>
                            <div class="row px-3">
                                <div class="col-4 px-0">
                                    <v-date-picker
                                        id="blackout_date"
                                        class="form-control form-control-sm"
                                        v-model="widgetCenters.payload.newBlackoutDate"
                                    ></v-date-picker>
                                </div>
                                <div class="col-6">
                                    <input
                                        id="blackout_description"
                                        type="text"
                                        class="form-control form-control-sm mb-1"
                                        v-model="widgetCenters.payload.newBlackoutDescription"
                                        placeholder="e.g. New Year's Eve"
                                    />
                                </div>
                                <div class="col-2 px-0">
                                    <button
                                        id="add-blackout"
                                        class="btn btn-sm btn-primary text-white"
                                        @click.prevent="addCentersBlackoutDate()"
                                    >
                                        Add
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <template v-if="widgetCenters.payload.address">
                        <div class="form-group row mb-0">
                            <label for="address1" class="col-4 mb-1">Address 1:</label>
                            <div class="col-8">
                                <input
                                    id="address1"
                                    type="text"
                                    class="form-control form-control-sm mb-1"
                                    v-model="widgetCenters.payload.address.address1"
                                />
                            </div>
                        </div>
                        <div class="form-group row mb-0">
                            <label for="address2" class="col-4 mb-1">Address 2:</label>
                            <div class="col-8">
                                <input
                                    id="address2"
                                    type="text"
                                    class="form-control form-control-sm mb-1"
                                    v-model="widgetCenters.payload.address.address2"
                                />
                            </div>
                        </div>
                        <div class="form-group row mb-0">
                            <label for="city" class="col-4 mb-1">City:</label>
                            <div class="col-8">
                                <input
                                    id="city"
                                    type="text"
                                    class="form-control form-control-sm mb-1"
                                    v-model="widgetCenters.payload.address.city"
                                />
                            </div>
                        </div>
                        <div class="form-group row mb-0">
                            <label for="state" class="col-4 mb-1">State/Zip:</label>
                            <div class="col-8">
                                <div class="row px-3">
                                    <input
                                        id="state"
                                        v-mask="'AA'"
                                        type="text"
                                        class="form-control form-control-sm mb-1 col-4"
                                        v-model="widgetCenters.payload.address.state"
                                    />
                                    <input
                                        id="zip"
                                        v-mask="['#####', '#####-####']"
                                        type="text"
                                        class="form-control form-control-sm mb-1 col-4 offset-1"
                                        v-model="widgetCenters.payload.address.zip"
                                    />
                                </div>
                            </div>
                        </div>
                    </template>

                    <div class="d-flex justify-content-end mt-3">
                        <!--
                        <button v-if="widgetCenters.payload.id" class="btn btn-sm btn-danger text-white mx-3" @click.prevent="deleteWidgetEntry('widgetCenters')">Delete</button>
-->
                        <button
                            id="save-new-center"
                            class="btn btn-sm btn-primary text-white"
                            @click.prevent="saveWidgetNewEntry('widgetCenters')"
                        >
                            Save
                        </button>
                    </div>
                </form>
                <template v-if="widgetCenters.errors">
                    <div v-for="f in Object.keys(widgetCenters.errors)" class="alert alert-danger">
                        <a href="#" class="close" data-dismiss="alert">&times;</a>
                        <strong>Error!</strong>
                        <span class="text-capitalize">{{ f.replace(/\s/g, " ") }}</span
                        >:
                        <span class="comma-list" v-for="e in widgetCenters.errors[f]">{{ e }}</span>
                    </div>
                </template>
            </modal-component>
        </div>

        <table-input-widget
            v-for="w in [
                widgetTherapistTypes,
                widgetCredentials,
                widgetAppointmentTypes,
                widgetSpecialConditions,
            ]"
            :ref="w.ref"
            :key="w.key"
            :no-collapse="true"
            :loading="w.loading"
            :title="w.title"
            :fields="w.fields"
            :data-source="w.dataSource"
            :table-class="w.tableClass"
            :widget-errors="w.errors"
            @delete="deleteWidgetEntry(w.ref, $event)"
            @edit="editWidgetEntry(w.ref, $event)"
        >
            <template slot="bottom">
                <form class="row form-group">
                    <div v-for="f in w.fields" :class="[`col-${f.widthBase12}`, f.class]">
                        <multi-field
                            :name="f.prop"
                            v-model="w.payload[f.prop]"
                            :type="f.type"
                            :placeholder="f.placeholder"
                            :options="f.options"
                            @focus="setMainAction(w.ref, 'save')"
                            v-if="!['select-multiple', 'datalist'].includes(f.type)"
                        ></multi-field>
                        <select
                            v-else-if="['select-multiple'].includes(f.type)"
                            multiple
                            v-model="w.payload[f.prop]"
                            class="form-control form-control-sm taller"
                            @focus="setMainAction(w.ref, 'save')"
                        >
                            <option v-for="o in f.options" :value="o.value">{{ o.title }}</option>
                        </select>
                        <template v-else-if="['datalist'].includes(f.type)">
                            <input
                                type="text"
                                class="form-control form-control-sm"
                                :list="`${f.prop}-list`"
                                :name="f.prop"
                                :placeholder="f.placeholder"
                                v-model="w.payload[f.prop]"
                            />
                            <datalist :id="`${f.prop}-list`">
                                <option :value="o" v-for="o in f.options">{{ o }}</option>
                            </datalist>
                        </template>
                    </div>
                    <div class="col-1 px-0">
                        <input-actions-widget
                            :widget="w"
                            :main="w.mainAction"
                            @cancel-widget-edit="cancelWidgetEdit(w.ref)"
                            @save-widget-new-entry="saveWidgetNewEntry(w.ref)"
                            @delete-widget-entry="deleteWidgetEntry(w.ref)"
                        ></input-actions-widget>
                    </div>
                </form>
            </template>
        </table-input-widget>
    </div>
</template>

<script>
import { fixDatePickers } from "../../plugins/fixDatePickers";
import TableInputWidget from "../ui/TableInputWidget";
import MultiField from "../ui/MultiField";
import InputActionsWidget from "../ui/InputActionsWidget";
import ModalComponent from "../ui/ModalComponent";

export default {
    name: "MyCenters",
    mixins: [fixDatePickers],
    props: ["organization"],
    components: {
        TableInputWidget,
        MultiField,
        InputActionsWidget,
        ModalComponent,
    },
    data() {
        return {
            widgetCenters: {
                loading: false,
                modalVisible: false,
                endpoint: "/api/organizations/organizationId/centers",
                fields: [
                    { prop: "name" },
                    { prop: "opening_hours" },
                    { prop: "blackout_dates" },
                    { prop: "address" },
                ],
                dataSource: [],
                payload: { address: {} },
                prop: "centers",
                errors: {},
            },

            therapistTypes: [],
            widgetTherapistTypes: {
                key: "therapist-types",
                ref: "widgetTherapistTypes",
                loading: false,
                title: "Titles, departments, billable hours",
                fields: [
                    {
                        title: "Job Title",
                        prop: "title",
                        widthBase12: 3,
                        type: "text",
                        placeholder: "Title",
                    },
                    {
                        title: "Department",
                        prop: "department",
                        widthBase12: 2,
                        type: "text",
                        placeholder: "Department",
                    },
                    {
                        title: "Dept #",
                        prop: "department_number",
                        widthBase12: 1,
                        type: "text",
                        placeholder: "Dept. #",
                    },
                    {
                        title: "Expected Billable Hrs.",
                        prop: "billable_hours",
                        widthBase12: 1,
                        type: "number",
                        placeholder: "Hrs",
                        suffix: "hrs per ",
                        class: "px-0 text-right mr-1",
                    },
                    {
                        title: " ",
                        prop: "billable_per",
                        widthBase12: 1,
                        type: "select",
                        options: [
                            { value: "day", title: "day" },
                            { value: "month", title: "month" },
                        ],
                        class: "px-0",
                    },
                    {
                        title: "Supervise",
                        prop: "monthly_supervise_percent",
                        widthBase12: 1,
                        type: "number",
                        placeholder: "% monthly hrs",
                        suffix: "% of monthly hrs",
                        rowClass: "px-0",
                    },
                    {
                        title: "Supervision",
                        prop: "monthly_supervised_percent",
                        widthBase12: 1,
                        type: "number",
                        placeholder: "% mo. hrs",
                        suffix: "% of mo. hrs",
                        rowClass: "px-0 text-nowrap",
                    },
                ],
                endpoint: "/api/organizations/organizationId/therapist_types",
                payload: {},
                prop: "therapistTypes",
                mainAction: "add",
                dataSource: [],
                tableClass: "small",
                errors: {},
            },

            widgetCredentials: {
                key: "credentials",
                ref: "widgetCredentials",
                loading: false,
                title: "Credentials",
                fields: [
                    {
                        title: "Type",
                        prop: "type",
                        widthBase12: 2,
                        type: "text",
                        placeholder: "Educational",
                    },
                    {
                        title: "Degree",
                        prop: "degree",
                        widthBase12: 2,
                        type: "text",
                        placeholder: "Bachelor's Degree",
                    },
                    {
                        title: "Description",
                        prop: "description",
                        widthBase12: 3,
                        type: "text",
                        placeholder: "Completed 4 year program",
                    },
                    {
                        title: "Titles",
                        prop: "therapist_types",
                        widthBase12: 3,
                        type: "select-multiple",
                        options: [],
                    },
                ],
                endpoint: "/api/organizations/organizationId/credentials",
                payload: {
                    therapist_types: [],
                },
                prop: "credentials",
                mainAction: "add",
                dataSource: [],
                tableClass: "small",
                errors: {},
            },

            widgetAppointmentTypes: {
                key: "appointment-types",
                ref: "widgetAppointmentTypes",
                loading: false,
                title: "Appointment types",
                fields: [
                    {
                        title: "Calendar description",
                        prop: "name",
                        widthBase12: 4,
                        type: "text",
                        placeholder: "Description",
                    },
                    {
                        title: "Payroll code",
                        prop: "type",
                        widthBase12: 2,
                        type: "text",
                        placeholder: "Code",
                    },
                    {
                        title: "Payroll type",
                        prop: "payroll_type",
                        widthBase12: 3,
                        type: "datalist",
                        placeholder: "Payroll name",
                    },
                    {
                        title: "Billable to client",
                        prop: "is_billable",
                        widthBase12: 1,
                        type: "bool",
                    },
                ],
                endpoint: "/api/organizations/organizationId/scheduling/appointment_types",
                payload: {},
                prop: "appointmentTypes",
                mainAction: "add",
                tableClass: "small",
                dataSource: [],
                errors: {},
            },

            widgetSpecialConditions: {
                key: "special-conditions",
                ref: "widgetSpecialConditions",
                loading: false,
                title: "Special conditions",
                fields: [
                    {
                        title: "Description",
                        prop: "description",
                        widthBase12: 3,
                        type: "text",
                        placeholder: "e.g. Bilingual - Spanish",
                    },
                    {
                        title: "Titles",
                        prop: "therapist_types",
                        widthBase12: 7,
                        type: "select-multiple",
                        options: [],
                    },
                ],
                endpoint: "/api/organizations/organizationId/special_conditions",
                payload: {
                    therapist_types: [],
                },
                prop: "specialConditions",
                mainAction: "add",
                dataSource: [],
                tableClass: "small",
                errors: {},
            },

            dates: [],
            newHoliday: {},
            dateRemove: null,
            isLoadingType: null,
            isFetching: false,
        };
    },
    mounted() {
        if (this.organization && this.organization.id && !this.isFetching) {
            this.initialize();
        }
    },
    computed: {
        sortedPayloadDates() {
            return this.widgetCenters.payload.dates
                ? this.widgetCenters.payload.dates.sort(
                      (a, b) => this.moment(a).format("X") > this.moment(b).format("X")
                  )
                : [];
        },
    },
    watch: {
        therapistTypes() {
            this.widgetTherapistTypes.dataSource = this.therapistTypes;
            let therapistTypesSelect = [];
            this.therapistTypes.forEach(t => {
                const therapistType = {};
                therapistType.value = t.title;
                therapistType.title = t.title;
                therapistTypesSelect.push(therapistType);
            });
            this.widgetSpecialConditions.fields.find(
                f => f.prop === "therapist_types"
            ).options = therapistTypesSelect;
            this.widgetCredentials.fields.find(
                f => f.prop === "therapist_types"
            ).options = therapistTypesSelect;
        },
        organization() {
            if (this.organization && this.organization.id && !this.isFetching) {
                this.initialize();
            }
        },
    },
    methods: {
        setMainAction(widgetName, action = "add") {
            this[widgetName].mainAction = action;
        },

        initialize() {
            this.isFetching = true;
            this.getTherapistTypes();
            [
                "widgetAppointmentTypes",
                "widgetSpecialConditions",
                "widgetCredentials",
                "widgetCenters",
            ].forEach(w => {
                this.getWidgetDataSource(w);
            });
            this.isFetching = false;
        },

        getWidgetDataSource(widgetName) {
            this[widgetName].loading = true;
            axios({
                method: "GET",
                url: this[widgetName].endpoint.replace("organizationId", this.organization.id),
            })
                .then(r => {
                    this[widgetName].loading = false;
                    this[widgetName].dataSource = this.treatSpecificWidgetsAfterFetch(
                        widgetName,
                        r.data.data
                    );
                })
                .catch(e => {
                    this[widgetName].loading = false;
                    console.error(e);
                });
        },

        editWidgetEntry(widgetName, id) {
            this.setMainAction(widgetName, "cancel");
            this[widgetName].errors = {};
            const payload = { ...this[widgetName].dataSource.find(w => w.id === id) }; //TODO: replace with = JSON.parse(JSON.stringify(this[widgetName].dataSource.find(w => w.id === id)))
            if (payload.cantEdit) return;
            this[widgetName].payload = payload;
            switch (widgetName) {
                case "widgetCenters":
                    this[widgetName].modalVisible = true;
                    const dates = this.dates.find(d => {
                        if (d) return d.id === id;
                    });
                    if (dates) this[widgetName].payload.dates = dates.dates.dates; //TODO: do we need this level of nesting?
                    break;
            }
        },

        cancelWidgetEdit(widgetName) {
            this.setMainAction(widgetName, "add");
            this.$refs[this[widgetName].ref][0].resetSelected();
            switch (widgetName) {
                case "widgetSpecialConditions":
                case "widgetCredentials":
                    this[widgetName].payload = {
                        therapist_types: [],
                    };
                    break;
                case "widgetCenters":
                    this[widgetName].payload = { address: {} };
                    break;
                default:
                    this[widgetName].payload = {};
            }
        },

        saveWidgetNewEntry(widgetName) {
            this[widgetName].errors = {};
            const payload = this.treatSpecificWidgetsBeforeSave(widgetName);
            if (!payload) return;
            axios({
                method: payload.id ? "PATCH" : "POST",
                url:
                    this[widgetName].endpoint.replace("organizationId", this.organization.id) +
                    (payload.id ? `/${payload.id}` : ""),
                data: payload,
            })
                .then(r => {
                    this[widgetName].payload = {};
                    this.getWidgetDataSource(widgetName);
                    if (this[widgetName].ref) {
                        this.$refs[this[widgetName].ref][0].resetSelected();
                    }
                    this.setMainAction(widgetName, "add");
                })
                .catch(e => {
                    console.error(e);
                    this.$set(this[widgetName], "errors", e.response.data.errors);
                });
        },

        deleteWidgetEntry(widgetName) {
            axios({
                method: "DELETE",
                url:
                    this[widgetName].endpoint.replace("organizationId", this.organization.id) +
                    "/" +
                    this[widgetName].payload.id,
            })
                .then(r => {
                    this[widgetName].payload = {};
                    this.getWidgetDataSource(widgetName);
                    this.$refs[this[widgetName].ref][0].resetSelected();
                    this.setMainAction(widgetName, "add");
                })
                .catch(e => {
                    console.error(e);
                    this.$set(this[widgetName], "errors", e.response.data.errors);
                });
        },

        treatSpecificWidgetsBeforeSave(widgetName) {
            let payload = this[widgetName].payload;
            switch (widgetName) {
                case "widgetTherapistTypes":
                    if (!payload.title) return false;
                    break;
                case "widgetAppointmentTypes":
                    payload.is_archived = 0;
                    if (!payload.is_billable) {
                        payload.is_billable = 0;
                    }
                    if (!payload.type || !payload.name) return false;
                    break;
                case "widgetCenters":
                    payload.blackout_dates = { dates: payload.dates };
                    payload = this.validateNewCenter(payload);
                    break;
            }
            return payload;
        },

        treatSpecificWidgetsAfterFetch(widgetName, data) {
            switch (widgetName) {
                case "widgetAppointmentTypes":
                    data.sort((a, b) => a.organization_id > b.organization_id); // Sorts global types first
                    data.forEach(d => {
                        // Sets can't delete flag on globals
                        if (!d.organization_id) {
                            d.cantEdit = true;
                        }
                    });
                    const index = data.filter(d => !d.organization_id).length;
                    data.splice(index, 0, { separator: true }); // Adds separator after globals
                    const uniquePayrollTypes = Array.from(new Set(data.map(d => d.payroll_type)));
                    let field = this[widgetName].fields.find(f => f.prop === "payroll_type");
                    field.options = uniquePayrollTypes;
                    break;
                case "widgetSpecialConditions":
                case "widgetCredentials":
                    this[widgetName].payload = {
                        therapist_types: [],
                    };
                    data.forEach(d => (d.therapist_types = d.therapist_types.map(dt => dt.title))); //Takes title from therapist_types objects
                    break;
                case "widgetCenters":
                    this.closeWidgetCentersModal();
                    this[widgetName].payload = { address: {} };
                    this.dates = data.map(d => d.blackout_dates);
                    data.forEach((d, i) => {
                        if (this.dates[i]) this.dates[i].id = d.id;
                        delete d.blackout_dates;
                    });
            }
            return data;
        },

        getTherapistTypes() {
            this.isLoadingType = "therapist_types";
            axios
                .get(`/api/organizations/${this.organization.id}/therapist_types`)
                .then(r => {
                    this.therapistTypes = r.data.data;
                    this.isLoadingType = null;
                })
                .catch(e => {
                    console.error(e);
                    this.isLoadingType = null;
                });
        },

        openWidgetCentersModal() {
            this.widgetCenters.modalVisible = true;
        },

        closeWidgetCentersModal() {
            this.widgetCenters.payload = { address: {} };
            this.widgetCenters.modalVisible = false;
        },

        validateNewCenter(payload) {
            if (!payload.name) {
                this.widgetCenters.errors = { name: ["Name needs to be filled"] };
                return null;
            }
            if (_.get(payload, "address.zip", "").length < 10) {
                this.widgetCenters.errors = { zip: ["Zip code must have 9 digits"] };
                return null;
            }
            return payload;
        },

        deleteBlackout(index) {
            this.widgetCenters.payload.dates.splice(index, 1);
        },

        addCentersBlackoutDate() {
            this.widgetCenters.errors = {};

            if (!this.widgetCenters.payload.newBlackoutDate) {
                this.widgetCenters.errors = { date: ["Date needs to be filled"] };
                return;
            }
            if (!this.widgetCenters.payload.newBlackoutDescription) {
                this.widgetCenters.errors = { description: ["Description needs to be filled"] };
                return;
            }

            const date = this.moment(this.widgetCenters.payload.newBlackoutDate).format(
                "YYYY-MM-DD"
            );
            const description = this.widgetCenters.payload.newBlackoutDescription;

            if (!this.widgetCenters.payload.dates) {
                this.widgetCenters.payload.dates = [];
            }

            this.widgetCenters.payload.dates.push({ date, description });

            this.widgetCenters.payload.newBlackoutDate = null;
            this.widgetCenters.payload.newBlackoutDescription = null;
        },
    },
};
</script>

<style scoped lang="scss">
.hoverable:hover {
    background: rgba(214, 69, 113, 0.1);
}

.hover-delete,
.hover-edit,
.hover-save {
    color: #6c757d;
}
.hover-delete:hover {
    color: #dc3545;
}
.hover-cancel:hover {
    color: #ffc107;
}
.hover-save:hover {
    color: #28a745;
}
.selected,
.selected:hover {
    background: #d64571;
    color: white;
}
.taller {
    height: 8rem;
    font-size: 85%;
}
</style>
